<template>
  <v-main>
    <v-container class='o-container'>
      <v-row>
        <v-col cols='12'>
          <v-card flat>
            <v-card-title>
              聯絡我們
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <contact-info></contact-info>
              <div class="mt-4">
                <contact-map></contact-map>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  components: {
    'contact-info': () => import('../components/contact/info'),
    'contact-map': () => import('../components/contact/map')
  },
  data: () => ({})
}
</script>
